import React from 'react';
import CompoundInputV3, {
  CompoundInputProps as CompoundInputPropsInterface,
} from 'Components/CompoundInput/CompoundInputV3';

type CompoundInputFieldArrayItemProps = {
  error?: string;
  children: any;
} & Partial<Omit<CompoundInputPropsInterface, 'children'>>;

function CompoundInputFieldArrayItemV3(
  props: CompoundInputFieldArrayItemProps,
): React.ReactElement {
  const { children, error, ...compoundInputProps } = props;

  return (
    <CompoundInputV3 {...compoundInputProps} error={error} spacing={2}>
      {children}
    </CompoundInputV3>
  );
}

export default React.memo(CompoundInputFieldArrayItemV3);
